/*
  Version 7 ("After dark"). Two small pointer effects; the page is complete without this
  file. Both only run when the layout has set "motion-ok" on <html> (so never under reduced
  motion) and only for a fine pointer (a mouse or trackpad). They write CSS custom
  properties that the stylesheet reads in transform and translate: nothing here changes
  layout.

  1. Hero: the sky and the bands of the aurora lean a few pixels towards the pointer, each
     by a different amount, so the light has depth. The white the containers stand on does
     not move: it has to stay behind the labels.
  2. Product tiles: the tile under the pointer tilts a few degrees towards it.
*/
(function () {
  var root = document.documentElement;
  if (!root.classList.contains('motion-ok')) return;
  if (!window.matchMedia || !window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

  var frame = 0;
  function onFrame(fn) {
    if (frame) return;
    frame = requestAnimationFrame(function () {
      frame = 0;
      fn();
    });
  }

  /* 1. Hero */
  var hero = document.querySelector('[data-v7-hero]');
  if (hero) {
    var hx = 0;
    var hy = 0;
    hero.addEventListener('pointermove', function (event) {
      var box = hero.getBoundingClientRect();
      hx = (event.clientX - box.left) / box.width - 0.5;
      hy = (event.clientY - box.top) / box.height - 0.5;
      onFrame(function () {
        hero.style.setProperty('--px', (hx * 2).toFixed(3));
        hero.style.setProperty('--py', (hy * 2).toFixed(3));
      });
    });
    hero.addEventListener('pointerleave', function () {
      hero.style.setProperty('--px', '0');
      hero.style.setProperty('--py', '0');
    });
  }

  /* 2. Product tiles (delegated: the grid is filtered and re-rendered by the theme script) */
  var tilted = null;
  function release() {
    if (!tilted) return;
    tilted.style.removeProperty('--rx');
    tilted.style.removeProperty('--ry');
    tilted = null;
  }
  document.addEventListener('pointermove', function (event) {
    var plate = event.target && event.target.closest ? event.target.closest('.hp-card3 > .hp-plate') : null;
    if (plate !== tilted) release();
    if (!plate) return;
    tilted = plate;
    var box = plate.getBoundingClientRect();
    var x = (event.clientX - box.left) / box.width;
    var y = (event.clientY - box.top) / box.height;
    onFrame(function () {
      if (tilted !== plate) return;
      plate.style.setProperty('--ry', ((x - 0.5) * 9).toFixed(2) + 'deg');
      plate.style.setProperty('--rx', ((0.5 - y) * 9).toFixed(2) + 'deg');
    });
  });
  document.addEventListener('pointerleave', release);
})();
